
import React from 'react';
import { Provider } from 'react-redux';
import store from '@/redux/store';

const ReduxWrapper = ({ element }:any) => (
    <Provider store={store}>{element}</Provider>
);

export default ReduxWrapper;